var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-textarea", {
    attrs: {
      outlined: _vm.outlined,
      "auto-grow": _vm.autoGrow,
      label: _vm.label,
      "hide-details": _vm.hideDetails,
      "error-messages": _vm.errorMessages,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
      "background-color": _setup.backgroundColor,
      rows: _vm.rows,
    },
    model: {
      value: _setup.model,
      callback: function ($$v) {
        _setup.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }